export default __webpack_public_path__ + "static/media/pingPongBall.25bd2cff.png";